import { z } from "zod";

export const BaseFilterInputSchema = z.object({
    order: z.string().nullable().default(null),
    limit: z.number().default(25),
    page: z.number().default(1),
});

export type BaseFilterInput = z.infer<typeof BaseFilterInputSchema>;